import { render, staticRenderFns } from "./NetworkLayerComponent.vue?vue&type=template&id=485de178&"
import script from "./NetworkLayerComponent.vue?vue&type=script&lang=js&"
export * from "./NetworkLayerComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetworkLayerComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports